import { Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { IHome_LatestPublicationResponse } from '@shared/constants/models.const';
import { E_DATE_FORMAT, E_FILE_EXTENSION, E_FILE_PREVIEW } from '@shared/constants/enums.const';
import { RemoveHtmlPipe } from '@shared/pipes/remove-html.pipe';
import { HelperService } from '../../../../../../services/helper.service';

export enum PublicationsType {
  LATEST = 'LATEST',
  RELATED = 'RELATED',
}

@Component({
  selector: 'app-publication-card',
  imports: [
    NgOptimizedImage,
    RemoveHtmlPipe,
  ],
  templateUrl: './publication-card.component.html',
  styleUrl: './publication-card.component.scss',
})
export class PublicationCardComponent {

  newTabLink = input(false);

  noLeftMargin = input(false);
  publicationData = input.required<IHome_LatestPublicationResponse | any>();
  hasDesc = input<boolean>(false);
  cardType = input<PublicationsType>(PublicationsType.LATEST);
  isLast = input<boolean>(false);
  publicationsType = PublicationsType;
  protected readonly E_DATE_FORMAT = E_DATE_FORMAT;

  constructor(
    public HELPER: HelperService,
  ) {
  }

  get thumbnailImage(): string {
    if (this.publicationData().thumbnail) {
      return this.publicationData().thumbnail.sourceUrl || E_FILE_PREVIEW.placeholder;
    } else {
      if (this.publicationData().document?.extension) {
        switch (this.publicationData().document?.extension) {
          case E_FILE_EXTENSION.xls:
            return E_FILE_PREVIEW.xls;
          case E_FILE_EXTENSION.docx:
            return E_FILE_PREVIEW.doc;
          default:
            return E_FILE_PREVIEW.placeholder;
        }
      }
    }

    return E_FILE_PREVIEW.placeholder;

  }

  getUrl(): string {
    return this.HELPER.getUrl(this.publicationData().sourceUrl);
  }
}
